import styled from 'styled-components';
export var Toolbar = styled.div.withConfig({
  displayName: "Styles__Toolbar",
  componentId: "sc-5taeew-0"
})(["a,button{margin-right:6px;}"]);
export var ToolbarWrapper = styled.div.attrs({
  className: 'toolbar-wrapper'
})`
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 54px;
    width: 100%;
    flex-wrap: wrap;
    gap: 8px;

    @media (min-width: 768px) and (max-width: 992px) {
        margin-bottom: 6px;
    }

    @media screen and (max-width: 576px) {
        display: block;
        height: auto;
    }

    & > div {
        min-height: 54px;
        display: inline-flex;
        align-items: center;
        
        @media screen and (max-width: 576px) {
            width: 100%;
            flex-flow: wrap;
        }

        &:empty {
            display: none;
        }

        /* Ensure right container stays together and right-aligned when wrapping */
        &:last-child {
            flex-wrap: nowrap;
            margin-left: auto;
            flex-shrink: 0;
        }
    }

    & > div:nth-child(2) a,
    & > div:nth-child(2) button,
    & > div:nth-child(2) textarea {
        margin: 0 0 0 8px;
        
        @media screen and (max-width: 576px) {
            width: auto;
            margin-right: 8px;
        }
    }
`;